import { TLoadable, createLoaded, createUnloaded, isUnloaded, createLoading, createLoadErrored } from "../../sg-core/models/ILoadable";
import { useFileUploadService } from "../context/FileUploadServiceContext";
import { useState, useEffect } from "react";

const useFileToken = (): TLoadable<string> => {
    const uploadService = useFileUploadService();

    if (!uploadService) {
        throw new Error("[useFileToken] This hook cannot be called outside of a file upload context");
    }

    const [token, setToken] = useState<TLoadable<string>>(createUnloaded());

    useEffect(() => {
        const getter = async () => {
            setToken(createLoading());

            const result = await uploadService.getFileToken();
            if (result.isSuccess) {
                setToken(createLoaded(result.value));
            } else {
                setToken(createLoadErrored(result.error));
            }
        };
        if (isUnloaded(token)) {
            getter();
        }
    }, [uploadService]);// eslint-disable-line

    return token;
};

export default useFileToken;
